import React, {PropTypes} from 'react';
import { connect } from 'react-redux'
import { FormGroup, ControlLabel, Button, Row, Col, Modal, HelpBlock } from 'react-bootstrap';
import Classnames from 'classnames';

class AccountantProfileSaveAlertModal extends React.Component {

  handleCancel(){
    const {onCancel, dispatch} =this.props
    if (onCancel) {
      onCancel()
    } else {
      dispatch({type: "HIDE_MODAL"})
    }
  }

  handleOk(){
    const {onOk, dispatch} =this.props
    if (onOk) {
      onOk()
    } else {
      dispatch({type: "HIDE_MODAL"})
    }
  }

  render() {
    const { showModal, modalTitle, modalBody, alertStyle, onOk, onCancel, okButtonTitle, cancelButtonTitle } = this.props

    const btnInlineStyle =   {
        width: "100%",
        height: "45px",
        fontSize: "18px"
    }
    const fullWidth = {
        width: "100% ",
        textAlign: "center",
        fontSize: "18px"
    }

    return (
      <div className="subscription-form-box">
        <Modal bsSize="small" show={showModal} onHide={this.handleCancel.bind(this)} dialogClassName="custom-modal" >
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={ 12 } sm={ 12 }>
                <FormGroup controlId="alert-modal-body">
                  <div className="full-width-center-text" style={fullWidth}>
                     {modalBody}
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <div className="full-width-center-text" style={fullWidth}>
                <Button onClick={this.handleOk.bind(this)} className="btn-main-green" style={btnInlineStyle} type="submit">
                  {okButtonTitle}
                </Button>
              </div>
            </Row>

          </Modal.Body>
        </Modal>

      </div>
    );
  }
}

AccountantProfileSaveAlertModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string.isRequired,
  modalBody: PropTypes.string.isRequired,
  alertStyle: PropTypes.string,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  okButtonTitle: PropTypes.string.isRequired,
  cancelButtonTitle: PropTypes.string

};

export default connect()(AccountantProfileSaveAlertModal)



// WEBPACK FOOTER //
// ./src/accountants/components/AccountantProfileSaveAlertModal.js